import { render, staticRenderFns } from "./QCloseratioDrilldown.vue?vue&type=template&id=81b4aa16&scoped=true&"
import script from "./QCloseratioDrilldown.vue?vue&type=script&lang=js&"
export * from "./QCloseratioDrilldown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b4aa16",
  null
  
)

export default component.exports